import { Table, Button, Pagination, Row, Col, Badge } from "react-bootstrap";
import { useState } from "react";
import { IoMdMore } from "react-icons/io";
import CustomPagination from "../../components/common/CustomPagination";
import moment from "moment";
import { RiSearchLine } from "react-icons/ri";

export default function DriverTable({ data, search, setSearch, pagination, pagehandler }) {

  return (
    <>
       
      <div className="da-table-wrapper mt-3">

        {/* TABLE */}
        <div className="table-responsive da-table">
          <Table hover>
            <thead>
              <tr>
                <th>Driver</th>
                <th>Total</th>
                <th>Completed</th>
                {/* <th>Cancelled</th> */}
                {/* <th>No Show</th> */}
                <th>Completion Rate</th>
                <th>Status</th>
                <th>Last Booking</th>
                <th>Last Activity</th>
              </tr>
            </thead>

            <tbody>
              {data?.length > 0 ? (
                data?.map((item, i) => (
                <tr key={i}>

                  {/* DRIVER */}
                  <td>
                    <div className="driver">
                      <img src={item?.driver?.profileImage || "assets/images/placeholder.png"}
                        alt="" />
                      <div>
                        <strong>{item?.driver?.name}</strong>
                        <p>{item?.driver?.phoneNumber}</p>
                      </div>
                    </div>
                  </td>

                  <td>{item?.totalBookings}</td>

                  {/* COMPLETED */}
                  <td className="green">
                    {item?.completedBookings}
                  </td>

                  {/* CANCELLED */}
                  {/* <td className="red">
                  {item?.cancelled}
                </td> */}

                  {/* NO SHOW */}
                  {/* <td className="orange">
                 {item.noshow}
                </td> */}

                  {/* PROGRESS */}
                  <td>
                    <div className="progress-wrap">
                      <span>{item?.completionRate}%</span>
                      <div className="bar">
                        <div style={{ width: `${item?.completionRate}%` }}></div>
                      </div>
                    </div>
                    </td>
                    
                    <td>
                      <Badge pill bg={item?.status === "ACTIVE" ? "success" : "secondary"}>
                        {item?.status}
                      </Badge>
                    </td>

                  {/* BOOKING */}
                  <td>
                    {moment(item?.booking?.createdAt).tz(item?.booking?.timezone || "UTC").format("MMM DD, h:mm A")}
                    <p className="mb-0">{item?.vehicle?.licensePlate}</p>
                  </td>

                  {/* ACTIVITY */}
                  <td>
                    {item?.lastActivity ? (
                        <>
                         {moment(item?.lastActivity?.mixedEventTimestamp?.$date || item?.lastActivity?.mixedEventTimestamp).tz(item?.booking?.timezone || "UTC").format("MMMM DD, hh:mm A")}
                        <p>{item?.lastActivity?.actualVehicleDirection === "ENTRY" && item?.lastActivity?.cameraDirection === "IN" ? "Check-in" : "Check-out"}</p>
                      </>
                    ) : (
                      <p>No activity found</p>
                    )}
                  </td>

                  {/* ACTION */}
                  {/* <td>
                  <Button size="sm" className="view-btns me-2" variant="outline-primary">
                     View
                  </Button>
                  <Button size="sm" className="view-btns" variant="outline-secondary">
                     <IoMdMore />
                  </Button>
                </td> */}

                </tr>
              ))) : (
                <tr>
                  <td colSpan="7" className="text-center mx-auto py-4">
                    No driver activity found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {/* PAGINATION */}
        <CustomPagination
          pagination={pagination}
          pagpagehandler={pagehandler}
        />

      </div>
    </>
  );
}